import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "form-row" }
const _hoisted_3 = { class: "form-group col-lg-6" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "p-error"
}
const _hoisted_6 = {
  key: 1,
  class: "p-error"
}
const _hoisted_7 = { class: "form-row" }
const _hoisted_8 = { class: "form-group col col-lg-9" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "p-error"
}
const _hoisted_11 = {
  key: 1,
  class: "p-error"
}
const _hoisted_12 = {
  key: 2,
  class: "p-error"
}
const _hoisted_13 = {
  key: 0,
  class: "form-row"
}
const _hoisted_14 = { class: "form-group col col-lg-9" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "popover-icon pi pi-question" }, null, -1)
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "d-flex flex-wrap p-2 p-lg-0" }
const _hoisted_19 = ["alt", "src"]
const _hoisted_20 = { class: "text-bold ml-2 flex-1" }
const _hoisted_21 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_PopoverIcon = _resolveComponent("PopoverIcon")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.v$['askAQuestionMessageForm'])
    ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", {
              class: _normalizeClass({ required: _ctx.v$['askAQuestionMessageForm'].subject?.required })
            }, _toDisplayString(_ctx.$t("common.forms.lblSubject")), 3),
            _createVNode(_component_InputText, {
              modelValue: _ctx.v$['askAQuestionMessageForm'].subject.$model,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$['askAQuestionMessageForm'].subject.$model) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.shouldShowError(_ctx.v$['askAQuestionMessageForm'].subject) }),
              type: "text"
            }, null, 8, ["modelValue", "class"]),
            (_ctx.shouldShowError(_ctx.v$['askAQuestionMessageForm'].subject))
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  (!_ctx.v$['askAQuestionMessageForm'].subject.$model)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.v$["askAQuestionMessageForm"].subject?.required?.$message), 1))
                    : (_ctx.v$['askAQuestionMessageForm'].subject.$model)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.v$["askAQuestionMessageForm"].subject.maxLength?.$message), 1))
                      : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", {
              class: _normalizeClass({ required: _ctx.v$['askAQuestionMessageForm'].message?.required })
            }, _toDisplayString(_ctx.$t("common.forms.lblDescription")), 3),
            _createVNode(_component_Textarea, {
              modelValue: _ctx.v$['askAQuestionMessageForm'].message.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$['askAQuestionMessageForm'].message.$model) = $event)),
              class: _normalizeClass({ 'p-invalid': _ctx.shouldShowError(_ctx.v$['askAQuestionMessageForm'].message) }),
              rows: "5",
              type: "text"
            }, null, 8, ["modelValue", "class"]),
            (_ctx.shouldShowError(_ctx.v$['askAQuestionMessageForm'].message))
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  (!_ctx.v$['askAQuestionMessageForm'].message.$model)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_10, _toDisplayString(_ctx.v$["askAQuestionMessageForm"].message?.required?.$message), 1))
                    : (_ctx.v$['askAQuestionMessageForm'].message.minLength.$invalid)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.v$["askAQuestionMessageForm"].message.minLength?.$message), 1))
                      : (_ctx.v$['askAQuestionMessageForm'].message.maxLength.$invalid)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.v$["askAQuestionMessageForm"].message.maxLength?.$message), 1))
                        : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.isSupportQuestion)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("common.forms.lblAttachment")), 1),
                _createVNode(_component_PopoverIcon, { class: "d-inline-flex ml-0" }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", {
                      innerHTML: _ctx.$t('support.attachmentTooltip')
                    }, null, 8, _hoisted_16)
                  ]),
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_FileUpload, {
                  ref: "fileUploader",
                  auto: true,
                  "choose-label": _ctx.$t('common.chooseFile'),
                  "custom-upload": true,
                  "invalid-file-size-message": _ctx.$t('common.fileMayNotBeLargerThan', { fileSize: '20MB' }),
                  "max-file-size": 20971520,
                  mode: "basic",
                  name: "attachment",
                  onUploader: _ctx.onFileSelected
                }, null, 8, ["choose-label", "invalid-file-size-message", "onUploader"]),
                (_ctx.v$['askAQuestionMessageForm'].attachments.$model.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$['askAQuestionMessageForm'].attachments.$model, (file, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: file.name + file.type + file.size,
                            class: "my-2 p-1 d-flex shadow-sm align-items-center w-100",
                            style: {"border":"1px solid #dddd"}
                          }, [
                            _createElementVNode("div", null, [
                              (file.objectURL)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    alt: file.name,
                                    class: "",
                                    height: "50",
                                    role: "presentation",
                                    src: file.objectURL,
                                    width: "100"
                                  }, null, 8, _hoisted_19))
                                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 1,
                                    icon: ['far', 'file'],
                                    size: "2x"
                                  }))
                            ]),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(file.name), 1),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.formatSize(file.size)), 1),
                            _createVNode(_component_Button, {
                              class: "p-button-text p-button-danger p-button-rounded ml-2",
                              icon: "pi pi-trash",
                              label: _ctx.isSmallScreen ? _ctx.$t('common.remove') : '',
                              title: _ctx.$t('common.remove'),
                              onClick: ($event: any) => (_ctx.onFileRemoved(file, index))
                            }, null, 8, ["label", "title", "onClick"])
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("small", null, _toDisplayString(_ctx.$t("common.xOfY", [_ctx.formatSize(_ctx.totalSize), _ctx.formatSize(_ctx.totalSizeLimit)])), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}